import { render } from "./PurchasesProductsModal.vue?vue&type=template&id=44f19bd3&scoped=true"
import script from "./PurchasesProductsModal.vue?vue&type=script&lang=js"
export * from "./PurchasesProductsModal.vue?vue&type=script&lang=js"

import "./PurchasesProductsModal.vue?vue&type=style&index=0&id=44f19bd3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44f19bd3"]])

export default __exports__